import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ButtonClickAsyncEvent } from "src/app/components/ui/button/button-click-async-event";

@Component({
  selector: "pms-page-datagrid-toolbar-action",
  template: "",
  standalone: false
})
export class PageDatagridToolbarActionComponent {
  @Input()
  icon: string | undefined;

  @Input()
  title?: string;

  @Input()
  disabled!: boolean;

  @Input()
  enableBySelection: { single: boolean; multiple: boolean } | null = null;

  @Output()
  onClick: EventEmitter<any[]> = new EventEmitter<any[]>();

  @Output()
  onClickAsync: EventEmitter<ButtonClickAsyncEvent> =
    new EventEmitter<ButtonClickAsyncEvent>();
}
